import API from './client'

export interface ChatMessage {
  _id: string
  conversationId: string
  senderId: string
  senderRole: 'livreur' | 'admin'
  senderName: string
  content: string
  readAt?: string
  createdAt: string
}

export interface AdminConversation {
  _id: string
  livreurId: string
  livreurName: string
  livreurAvatar?: string
  lastMessage?: {
    content: string
    senderRole: 'livreur' | 'admin'
    createdAt: string
  }
  adminUnread: number
  lastMessageAt: string
}

export const chatAPI = {
  listConversations: async (): Promise<AdminConversation[]> => {
    const { data } = await API.get<{ conversations: AdminConversation[] }>('/chat/conversations')
    return data.conversations
  },

  getMessages: async (
    conversationId: string,
    page = 1
  ): Promise<{ messages: ChatMessage[]; total: number }> => {
    const { data } = await API.get(`/chat/conversations/${conversationId}/messages`, {
      params: { page, limit: 50 },
    })
    return data
  },

  sendMessage: async (conversationId: string, content: string): Promise<ChatMessage> => {
    const { data } = await API.post<{ message: ChatMessage }>(
      `/chat/conversations/${conversationId}/messages`,
      { content }
    )
    return data.message
  },

  markRead: async (conversationId: string): Promise<void> => {
    await API.patch(`/chat/conversations/${conversationId}/read`)
  },
}
